import '../styles/main.css';
import Illustration from '../assets/signupSVG.svg';
import { Button } from 'react-materialize';

export default function signUp(){
    return(
        <div className='signup-container'>
            <div className='item-one'>
                <img src={Illustration} alt='illustration' className='illustration' />
            </div>
            <div className='item-two'>
                <div className='signup-credentials'>
                    <input type='email' className='email' placeholder='Email'/>
                    <input type='text' className='username' placeholder='Username'/>
                    <input type='text' className='mobile-number' placeholder='Mobile Number'/>
                    <input type='password' className='password' placeholder='password'/>
                </div>
                <Button
                        style= {{
                            margin:'1rem 0 0 0',
                            marginRight: '5px',
                            background: '#306EFF'
                        }}
                        node="button"
                        waves="#306EFF"
                    >
                        SIGNUP
                </Button>
            </div>
        </div>
    )
}
